export var Denominations;
(function (Denominations) {
    Denominations["eth"] = "eth";
    Denominations["usd"] = "usd";
})(Denominations || (Denominations = {}));
export var DenominationAddresses;
(function (DenominationAddresses) {
    DenominationAddresses["eth"] = "0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE";
    DenominationAddresses["usd"] = "0x0000000000000000000000000000000000000348";
})(DenominationAddresses || (DenominationAddresses = {}));
//# sourceMappingURL=ChainlinkFeedsRegistryTypes.js.map